<div class="main-container">
  <z-broadcast-debug></z-broadcast-debug>

  <z-header></z-header>

  <div class="main-content">
    <router-outlet></router-outlet>
  </div>

  <z-footer></z-footer>
</div>

<z-select-language></z-select-language>

<z-notifications></z-notifications>
